export default "__VITE_ASSET__df590110__"